module.exports = __webpack_public_path__ + "img/angel-1.ba95e25f.webp";